var app = angular.module('leonardo');

var OnDemandInstructionsFilter = function ($filter) {
  return function (list, text) {

    var list_name = $filter('filter')(list, {name:text});
    var list_body = $filter('filter')(list, {body:text});
    var list_teaser = $filter('filter')(list, {teaser:text});
    var list_description = $filter('filter')(list, {description:text});

    return _.union(list_name, list_body, list_teaser, list_description);
  }
};

app.filter('onDemandInstructionsFilter', ['$filter', OnDemandInstructionsFilter]);
